import { Flex, OnboardingLayout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { UploadDocumentType } from "../../../types";
import { CashFlowForecastDocumentUpload, useDocumentNavigationActions, MESSAGES } from "../components";

export const CashFlowForecastDocumentUploadPage = () => {
  const intl = useIntl();

  const { primaryAction, secondaryAction } = useDocumentNavigationActions({
    forType: UploadDocumentType.CASH_FLOW_FORECAST,
  });

  return (
    <OnboardingLayout
      variant="wide"
      title={intl.formatMessage(MESSAGES.revenueProjectionsTitle)}
      actions={{ primary: primaryAction, secondary: secondaryAction }}
    >
      <Flex maxWidth="550px">
        <CashFlowForecastDocumentUpload />
      </Flex>
    </OnboardingLayout>
  );
};
